export namespace AccountConstant {
  export const SIGN_APPLICATION_PREFIX_KEY = 'isAccountAgreementAccepted';
}

export namespace AccountDocumentUriConstant {
  export const SIMPLE_IRA_CONTRIBUTION_FORM =
    'https://legacy.tradingblock.com/Admin/Forms/Apex/Cashiering/SIMPLE_IRA_Deposit_Slip.pdf';
  export const IRA_CONTRIBUTION_FORM =
    'https://legacy.tradingblock.com/Admin/Forms/Apex/Cashiering/IRA_Contribution_Form.pdf';
  export const CORPORATATE_FORM = 'https://legacy.tradingblock.com/docs/EntityAccountAppPDFs/TB_AppPack_Corporate.pdf';
  export const LLC_FORM = 'https://legacy.tradingblock.com/docs/EntityAccountAppPDFs/TB_AppPack_LLC.pdf';
  export const PERSONAL_TRUST_FORM =
    'https://legacy.tradingblock.com/docs/EntityAccountAppPDFs/TB_AppPack_Trust_ind.pdf';
  export const BUSINESS_TRUST_FORM = 'https://legacy.tradingblock.com/docs/EntityAccountAppPDFs/TB_AppPack_Trust.pdf';
  export const PARTNERSHIP_FORM =
    'https://legacy.tradingblock.com/docs/EntityAccountAppPDFs/TB_AppPack_Partnership.pdf';
}
